import React, { useContext } from 'react'
import { ListGroup } from 'react-bootstrap'
import { NavLink } from 'react-router-dom'

import NavIcon from '../nav_icon'
import NavBadge from '../nav_badge'

import ThemeContext from 'src/components/system_wide/theme_context'
import * as actionType from 'src/lib/actions'
import useWindowSize from 'src/components/hooks/use_window_size'
import { WithCapabilitiesWrapper } from 'src/enhancers/with_capabilities'

const NavItem = ({ item }) => {
  const windowSize = useWindowSize()
  const configContext = useContext(ThemeContext)
  const { dispatch } = configContext

  let itemTitle = item.title
  if (item.icon) {
    itemTitle = <span className="pcoded-mtext">{item.title}</span>
  }

  let itemTarget = ''
  if (item.target) {
    itemTarget = '_blank'
  }

  let subContent
  if (item.external) {
    subContent = (
      <a href={item.url} target="_blank" rel="noopener noreferrer">
        <NavIcon items={item} />
        {itemTitle}
        <NavBadge items={item} />
      </a>
    )
  } else {
    subContent = (
      <WithCapabilitiesWrapper {...item.caps}>
        <NavLink to={item.url} className="nav-link" target={itemTarget}>
          <NavIcon items={item} />
          {itemTitle}
          <NavBadge items={item} />
        </NavLink>
      </WithCapabilitiesWrapper>
    )
  }
  let mainContent = ''

  if (windowSize.width < 992) {
    mainContent = (
      <ListGroup.Item
        as="li"
        bsPrefix=" "
        className={item.classes}
        onClick={() => dispatch({ type: actionType.COLLAPSE_MENU })}>
        {subContent}
      </ListGroup.Item>
    )
  } else {
    mainContent = (
      <ListGroup.Item as="li" bsPrefix=" " className={item.classes}>
        {subContent}
      </ListGroup.Item>
    )
  }

  return <React.Fragment>{mainContent}</React.Fragment>
}

export default NavItem
